export default __webpack_public_path__ + "static/go-to-pay-via-qr-dbf9ee208aad91c62d7ee5daf82b9a6c.gif";